module.exports = __webpack_public_path__ + "static/media/pling.568c4522.mp3";